export const deleteRoleDialogTranslations = {
    en: {
        confirmMessage: 'Are you sure you want to delete the role?',
        yes: "Yes",
        deleteSuccess: "Role Deleted Successfully",
        deleteError: "Something went wrong. Please try again later."
    },
    mr: {
        confirmMessage: 'तुम्हाला खात्री आहे की तुम्ही भूमिका हटवू इच्छिता?',
        yes: "होय",
        deleteSuccess: "भूमिका यशस्वीरित्या हटवली",
        deleteError: "काहीतरी चूक झाली. कृपया पुन्हा प्रयत्न करा."
    }
};